import { render, staticRenderFns } from "./learning.layout.vue?vue&type=template&id=72af722a"
import script from "./learning.layout.vue?vue&type=script&lang=ts"
export * from "./learning.layout.vue?vue&type=script&lang=ts"
import style0 from "./learning.layout.vue?vue&type=style&index=0&id=72af722a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports